import React from "react";
import { Lock } from "lucide-react";

export interface ForbiddenStateProps {
  title?: string;
  description?: string;
}

const ForbiddenState: React.FC<ForbiddenStateProps> = ({
  title = "Access denied",
  description = "You don't have permission to view this information. Contact your administrator.",
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 text-center py-8">
      <div className="w-12 h-12 rounded-full bg-[#F2F6F9] text-[#1D5176] flex items-center justify-center border border-[#C9DDF1]">
        <Lock className="w-6 h-6" />
      </div>
      <div className="text-sm font-semibold text-gray-800">{title}</div>
      <div className="text-sm text-gray-600 max-w-md">{description}</div>
    </div>
  );
};

export default ForbiddenState;


